import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Tabela from "../../components/Tabela";
import { buscaChecklist } from "../../types/checklistData";
import { deleteChecklist, getChecklist } from "../../api/checkilstApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Checklist: React.FC = () => {
  const [checklist, setChecklist] = useState<buscaChecklist[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchChecklist = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const checklistData = await getChecklist(token);
        setChecklist(checklistData);
      } catch (error) {
        toast.error("Erro ao buscar checklists!");
        console.error("Erro ao buscar checklists:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchChecklist();
  }, []);

  const handleAddChecklist = () => {
    navigate("/checklist/builder");
  };

  const handleEditChecklist = (id: string) => {
    navigate(`/editarChecklist/${id}`);
  };

  const handleViewChecklist = (id: string) => {
    navigate(`/checklist/${id}/grupos`);
  };

  const handleDeleteChecklist = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      await deleteChecklist(token, id);
      setChecklist(
        checklist.filter((checklist) => checklist.id !== Number(id))
      );
      toast.success("Checklist excluído com sucesso!");
    } catch (error) {
      toast.error("Erro ao excluir Checklist!");
      console.error("Erro ao excluir Checklist:", error);
    }
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "descricao_checklist", label: "Descrição do Checklist" },
    {
      id: "fotos_checklist",
      label: "Fotos no Checklist",
      render: (value: boolean) => (value ? "Sim" : "Não"),
    },
    {
      id: "assinatura_checklist",
      label: "Assinatura no Checklist",
      render: (value: boolean) => (value ? "Sim" : "Não"),
    },
    { id: "template_checklist", label: "Template do Checklist" },
  ];

  const dadosConvertidos = checklist.map((checklist) => ({
    ...checklist,
    fotos_checklist: checklist.fotos_checklist ? "Sim" : "Não",
    assinatura_checklist: checklist.assinatura_checklist ? "Sim" : "Não",
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Checklists"
        colunas={colunas}
        dados={dadosConvertidos}
        onAdd={handleAddChecklist}
        onEdit={handleEditChecklist}
        onView={handleViewChecklist}
        onDelete={handleDeleteChecklist}
        loading={loading}
        showVisibilityIcon={true}
      />
    </Box>
  );
};

export default Checklist;
